import type { IValidatedResponse } from '../../httpClient';
import { deleteRequest } from '../../httpClient';
import type { IDeleteChallengeRequest } from './delete-challenge-request';
import type { IDeleteChallengeResponse } from './delete-challenge-response';
import { deleteChallengeResponseSchema } from './delete-challenge-response';

export async function deleteChallengeApi({
  id,
}: IDeleteChallengeRequest): Promise<IValidatedResponse<IDeleteChallengeResponse>> {
  return deleteRequest<IDeleteChallengeResponse>({
    path: `/sys/challenges/${id}`,
    schema: deleteChallengeResponseSchema,
  });
}
